"use client"

import { SessionProvider } from "next-auth/react"
import { ReactNode } from "react"
import { usePathname } from "next/navigation"
import { VisitorTracker } from "@/components/analytics/visitor-tracker"

export function AuthProvider({ children }: { children: ReactNode }) {
  const pathname = usePathname()
  // Platform guests must not inherit site sessions or login redirects.
  // Server-side IP and API authorization checks remain unchanged.
  if (pathname === "/embed/crazygames") return children

  return (
    <SessionProvider refetchInterval={5 * 60} refetchOnWindowFocus={false}>
      <VisitorTracker />
      {children}
    </SessionProvider>
  )
}
